import { Pipe, PipeTransform } from '@angular/core';
import { PropertyUtils } from '@article/util/property-utils';
import { PropertyVO } from '@project/components/article/model/vo/property.vo';

@Pipe({name: 'propertyValue'})
export class PropertyValuePipe implements PipeTransform {

  transform(properties: PropertyVO[], name: string, type: 'string' | 'float' | 'int' | 'boolean', isArray = false ): unknown {
    switch (type) {
      case 'string':
        return isArray ? PropertyUtils.getStringPropertyValues(properties, name) : PropertyUtils.getStringPropertyValue(properties, name);
      case 'float':
        return isArray ? PropertyUtils.getFloatPropertyValues(properties, name) : PropertyUtils.getFloatPropertyValue(properties, name);
      case 'int':
        return isArray ? PropertyUtils.getIntPropertyValues(properties, name) : PropertyUtils.getIntPropertyValue(properties, name);
      case 'boolean':
        return isArray ? PropertyUtils.getBooleanPropertyValues(properties, name) : PropertyUtils.getBooleanPropertyValue(properties, name);
      default:
        throw new Error(`Unsupported type: ${type}`);
    }
  }
}
